export default __webpack_public_path__ + "static/bbqguru-banner-2-cde90f754a81ad48fdc32ca9a65a2f46.webp";